import WindsorApi from '../api/WindsorApi';
import { decorate, observable } from 'mobx';

const RELOAD_PERIOD_MILLIS = 5 * 60 * 1000; // 5 minutes

class ApprovalStore {
    private user: any;
    private windsorApi: WindsorApi;

    approvals: any[] = null;
    pendingApprovalCount: number = 0;

    constructor(user: any, windsorApi: WindsorApi) {
        this.user = user;
        this.windsorApi = windsorApi;
        this.loadApprovals();
        setInterval(() => this.loadApprovals(), RELOAD_PERIOD_MILLIS);
    }

    hardRefresh() {
        this.approvals = null;
        this.pendingApprovalCount = 0;
        this.loadApprovals();
    }

    async loadApprovals() {
        // TODO: Check if load is already in progress
        const rawApprovals = await this.windsorApi.getApprovalRequests();

        rawApprovals.sort((a, b) => b.ApprovalRequestCreationTime - a.ApprovalRequestCreationTime);

        let pendingApprovalCount = 0;
        this.approvals = rawApprovals.map(approval => {
            let pending = !approval.Approvals.some(desc => desc.User === this.user.email);
            let groupMatches = [];

            Object.keys(approval.Approvers.Groups).forEach(group => {
                if (this.user.GroupIDs.includes(group)) {
                    groupMatches.push(group);
                }
            });

            approval.Approvers.PreApprovers.forEach(group => {
                if (this.user.GroupIDs.includes(group)) {
                    groupMatches.push(group);
                }
            });

            if (pending && groupMatches.length) {
                pendingApprovalCount++;
            }

            const userApprovals = approval.Approvals.reduce((accumulator, record) => {
                accumulator[record.User] = record.ApprovalValue;
                return accumulator;
            }, {});

            const approvalCounts = Object.keys(userApprovals).reduce((accumulator, user) => {
                accumulator[userApprovals[user] ? 'approved' : 'rejected']++;
                return accumulator;
            }, { approved: 0, rejected: 0 });

            return { ...approval, pending, groupMatches, approvalCounts };
        });

        this.pendingApprovalCount = pendingApprovalCount;
    }

    approve(approval: any) {
        return this.windsorApi.approveApprovalRequest(approval).then(res => {
            this.hardRefresh();
            return res;
        });
    }

    reject(approval: any) {
        return this.windsorApi.rejectApprovalRequest(approval).then(res => {
            this.hardRefresh();
            return res;
        });
    }

    delete(approval: any) {
        return this.windsorApi.deleteApprovalRequest(approval).then(res => {
            this.hardRefresh();
            return res;
        });
    }
}

decorate(ApprovalStore, {
    approvals: observable,
    pendingApprovalCount: observable
});

export default ApprovalStore;